import { authorizeGetRequest, authorizePatchRequest } from "api";
import {
  IDispatchConfiguration,
  IDispatchConfigurationResponse,
  ISearchRangeSettingResponse,
  ISettingRequest,
  ISettingResponse,
} from "models/setting";

export const fetchSettingApi = () => {
  return authorizeGetRequest<ISettingResponse>("configurations");
};

export const fetchSearchRangeSettingApi = () => {
  return authorizeGetRequest<ISearchRangeSettingResponse>(
    "configurations/search-radius"
  );
};

export const fetchDispatchConfigurationApi = () => {
  return authorizeGetRequest<IDispatchConfigurationResponse>(
    "configurations/dispatch"
  );
};

export const updateDispatchConfigurationApi = (
  data: IDispatchConfiguration
) => {
  // According to DISPATCH_CONFIGURATION_API_FORMAT.md:
  // Request format should be: { "max_expansion_multiplier": 3.0, "timeout_minutes": 5.0, "cycle_count": 3 }
  // max_expansion_multiplier and timeout_minutes must be floats (not integers)
  // cycle_count must be an integer
  // Ensure values are explicitly floats by parsing and ensuring they have decimal points
  const maxExpansion = parseFloat(String(data.max_expansion_multiplier));
  const timeoutMinutes = parseFloat(String(data.timeout_minutes));
  const cycleCount = parseInt(String(data.cycle_count), 10);

  // Ensure they are valid numbers and not NaN
  if (isNaN(maxExpansion) || isNaN(timeoutMinutes) || isNaN(cycleCount)) {
    throw new Error("Invalid dispatch configuration values");
  }

  const payload = {
    max_expansion_multiplier: maxExpansion,
    timeout_minutes: timeoutMinutes,
    cycle_count: cycleCount,
  };

  console.log("📤 API: Updating dispatch configuration");
  console.log("📤 API: Endpoint: PATCH configurations/dispatch");
  console.log("📤 API: Payload:", JSON.stringify(payload, null, 2));
  console.log("📤 API: Payload types:", {
    max_expansion_multiplier: typeof payload.max_expansion_multiplier,
    timeout_minutes: typeof payload.timeout_minutes,
    cycle_count: typeof payload.cycle_count,
  });
  console.log("📤 API: Values:", {
    max_expansion_multiplier: payload.max_expansion_multiplier,
    timeout_minutes: payload.timeout_minutes,
    cycle_count: payload.cycle_count,
  });
  console.log("📤 API: Token present:", !!localStorage.getItem("token"));

  return authorizePatchRequest<IDispatchConfigurationResponse>(
    "configurations/dispatch",
    payload
  );
};

export const updateSettingApi = (data: ISettingRequest) => {
  return authorizePatchRequest<ISettingResponse>("configurations", data);
};
